import React, { Component } from 'react';
import AnimatedButton from 'common/components/animated_button';

const initialState = { successMsg: '', errorMsg: '', processing: false, timer: null };

class AnimatedBtnExample extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.play = this.play.bind(this);
  }

  componentWillMount() {
    this.setState({ timer: setInterval(this.play, 3000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  play() {
    /* alternate between processing, success and error states */
    const { processing, successMsg } = this.state;
    let newState = { processing: false };
    if (!processing) {
      newState = { processing: true, successMsg: '', errorMsg: '' };
      if (successMsg) newState.errorMsg = 'Something went wrong!';
      else newState.successMsg = 'Saved Successfully!';
    }
    this.setState(newState);
  }

  render() {
    const { errorMsg, successMsg, processing } = this.state;

    return (
      <AnimatedButton
        processing={processing}
        type="submit"
        label="Save"
        processingLabel="Saving..."
        errorMsg={errorMsg}
        successMsg={successMsg}
      />
    );
  }
}

export default AnimatedBtnExample;



// WEBPACK FOOTER //
// ./styleguide/components/animated_btn.jsx